@switch (type) {
  @case (PrivilegeType.USER) {
    @switch (scope) {
      @case (PrivilegeScope.GLOBAL) {
        <ziro-text [fieldId]="'upn'" [inlineLabel]="false"></ziro-text>
      }
      @case (PrivilegeScope.TENANT) {
        <ziro-typeahead [fieldId]="'upn'" [inlineLabel]="false"></ziro-typeahead>
      }
    }
  }
  @case (PrivilegeType.GROUP) {
    @if (scope === PrivilegeScope.GLOBAL) {
      <ziro-select [fieldId]="'tenantGuid'" [inlineLabel]="false"></ziro-select>
    }
    <div class="name-container d-flex">
      <ziro-select [fieldId]="'displayName'" [inlineLabel]="false" class="flex-grow-1"></ziro-select>
      <div class="group-members">
        <ziro-view-members
          [members]="usersInGroup"
          [state]="viewMembersState"
          [disabled]="usersInGroup.length === 0"
        ></ziro-view-members>
      </div>
    </div>
  }
}
<ziro-radio
  [fieldId]="'role'"
  [ngClass]="{ 'dirty-privileges': isPrivilegesDirty, roles: formData?.role }"
></ziro-radio>

<div [hidden]="formData.role !== PrivilegeRole.CUSTOM" class="custom-privilege-container">
  <div class="privilege-section-header text-muted">
    {{ 'tkey;admin.user_group_privileges_modal.privileges.teams_management' | translate }}
  </div>
  <div class="privilege-section-content">
    <div class="privilege-section-item"><ziro-checkbox [fieldId]="'teamsUserManagement'"></ziro-checkbox></div>
    @if (scope === PrivilegeScope.TENANT) {
      <div class="privilege-restrictions" [hidden]="!formData.teamsUserManagement">
        <ziro-radio [fieldId]="'teamsUserManagementRestrictedDialPlanGroupsAccess'"></ziro-radio>
        <div class="privilege-restrictions__entities">
          <ziro-select [fieldId]="'teamsUserManagementRestrictedDialPlanGroups'"></ziro-select>
        </div>
      </div>
    }
    <div class="privilege-section-item"><ziro-checkbox [fieldId]="'resourceAccountManagement'"></ziro-checkbox></div>
    <div class="privilege-section-item"><ziro-checkbox [fieldId]="'autoAttendantManagement'"></ziro-checkbox></div>
    <div class="privilege-section-item"><ziro-checkbox [fieldId]="'callQueueManagement'"></ziro-checkbox></div>
    <div class="privilege-section-item"><ziro-checkbox [fieldId]="'emergencyLocationManagement'"></ziro-checkbox></div>
  </div>
  <div class="privilege-section-header text-muted">
    {{ 'tkey;admin.user_group_privileges_modal.privileges.automation' | translate }}
  </div>
  <div class="privilege-section-content">
    <div class="privilege-section-item"><ziro-checkbox [fieldId]="'automation'"></ziro-checkbox></div>
  </div>
  <div class="privilege-section-header text-muted">
    {{ 'tkey;admin.user_group_privileges_modal.privileges.reports' | translate }}
  </div>
  <div class="privilege-section-content">
    <div class="privilege-section-item"><ziro-checkbox [fieldId]="'configurationReports'"></ziro-checkbox></div>
    <div class="privilege-section-item"><ziro-checkbox [fieldId]="'auditReports'"></ziro-checkbox></div>
    <div class="privilege-section-item"><ziro-checkbox [fieldId]="'cdrReports'"></ziro-checkbox></div>
  </div>
  <div class="privilege-section-header text-muted">
    {{ 'tkey;admin.user_group_privileges_modal.privileges.migration' | translate }}
  </div>
  <div class="privilege-section-content">
    <div class="privilege-section-item"><ziro-checkbox [fieldId]="'migration'"></ziro-checkbox></div>
  </div>
</div>
